export default __webpack_public_path__ + "static/global-2000-sustainability-3817f65074379a5178584702f3a4a97e.png";